module.exports = __webpack_public_path__ + "static/think-on-these-things-4de8c1aed1e0b7cd9f540d66de8b4f9a.jpg";